import React from 'react';
import PropTypes from 'prop-types';
import { FormLayoutFieldContainer } from '@fluid/layouts';

const LoginFdicMsg = (props) => {
    const { fdicConfig = {} } = props;
    const { loginPageComplianceLogo, loginPageInsuredStatement } = fdicConfig;

    return (
        <FormLayoutFieldContainer>
            <div className="fdic-info-container">
                <div className="fdic-logo-container">
                    <img
                        className="fdic-logo"
                        src={loginPageComplianceLogo}
                        alt="FDIC-logo"
                    />
                </div>
                <div className="fdic-message">{loginPageInsuredStatement}</div>
            </div>
        </FormLayoutFieldContainer>
    );
};

LoginFdicMsg.defaultProps = {};

LoginFdicMsg.propTypes = {
    fdicConfig: PropTypes.object,
};

export default LoginFdicMsg;
